(function () {
	const header = () => {
		const body = document.querySelector("body");
		const header = document.querySelector(".shopify-section-header");
		const searchModal = document.querySelector(".search-modal");
		const stickyHeader = document.querySelector(".header-wrapper");
		const headerDetails = document.querySelector(".menu-drawer-container");
		const megaMenuLinks = document.querySelectorAll(".header-mega-menu__have-submenu__list .first-link");
		const megaMenuItem = document.querySelectorAll(".header__megamenu-item");
		const headerSimpleMenuLinks = document.querySelectorAll('.header__submenu--simple .header__submenu-li');

		headerSimpleMenuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				headerSimpleMenuLinks.forEach((el) => {
					if (el === e.target) {
						el.querySelector('.header__submenu').classList.add('show-submenu');
						el.querySelector('.header__submenu').classList.remove('remove-submenu');
					} else {
						el.querySelector('.header__submenu').classList.remove('show-submenu');
						el.querySelector('.header__submenu').classList.add('remove-submenu');
					}

				})
			})
		})

		megaMenuItem.forEach((item) => {
			item.addEventListener("mouseenter", () => {
				stickyHeader.classList.add("mega-menu-open");
				if (header.classList.contains("header-overlay")) {
					header.classList.remove("color-inverse");
				}
				document.querySelector('.header-mega-menu__overlay').classList.add('active');
				document.querySelectorAll(".header__account details").forEach(item => item.removeAttribute('open'));
				document.querySelectorAll(".disclosure__button").forEach(button => button.setAttribute("aria-expanded", "false"));
				document.querySelectorAll(".disclosure__list").forEach(list => list.setAttribute("hidden", ""));
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = -2);
			})
			item.parentElement.addEventListener("mouseleave", () => {
				stickyHeader.classList.remove("mega-menu-open");
				if (header.classList.contains("header-overlay") /*&& !searchModal.classList.contains('active')*/ && !header.classList.contains('shopify-section-header-sticky')) {
					setTimeout(() => {
						header.classList.add("color-inverse");
					}, 200);
				}
				document.querySelector('.header-mega-menu__overlay').classList.remove('active');
				document.querySelectorAll(".header__submenu").forEach(item => item.style.zIndex = 'unset');
			})
		})

		megaMenuLinks.forEach((link) => {
			link.addEventListener("mouseenter", (event) => {
				megaMenuLinks[0].classList.add('remove-sub-links');
				megaMenuLinks.forEach((item) => {
					item.classList.remove('show-sub-links');
				})
				event.target.classList.add('show-sub-links');
			})
		})
		
		const headerIsAlwaysSticky =
			header
				.querySelector(".header-wrapper")
				.getAttribute("data-sticky-type") === "always";

		if (headerDetails) {
			headerDetails.addEventListener("toggle", function (e) {
				const colorScheme =
					this.querySelector("#menu-drawer").dataset.colorScheme;
				header.classList.toggle(colorScheme);
			});
		}
		document.addEventListener("keyup", (e) => {
			if (e.key === "Escape") {
				header.classList.remove("shopify-section-header-sticky", "animate");
				body.classList.remove("overflow-hidden");
			}
		});

		document.addEventListener("scroll", () => {
			let scrollTop = window.scrollY;
			if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.add("fixed", "animate");
			} else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
				header.classList.remove("fixed", "animate");
			}
		});

		const addBackground = () => {
			if (
				header.classList.contains("color-inverse") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.remove("color-inverse");
			}
		};

		const removeBackground = () => {
			if (document.body.classList.contains("overflow-hidden-tablet")) {
				return;
			}

			if (
				header.classList.contains("header-overlay") &&
				!header.classList.contains("shopify-section-header-sticky")
			) {
				header.classList.add("color-inverse");
			}
		};

		//header.addEventListener("mouseenter", addBackground);

		//header.addEventListener("focus", addBackground);

		//header.addEventListener("focusin", addBackground);

		//header.addEventListener("mouseleave", removeBackground);

		//header.addEventListener("focusout", removeBackground);
	};

	header();

	document.addEventListener("shopify:section:load", header);
	document.addEventListener("shopify:section:unload", header);
	document.addEventListener("shopify:section:reorder", header);
})();
